import styled from "styled-components";
const StyledWrapper = styled.div`
  .list-header {
    margin: 40px 0 15px 0;
    font-weight: 400;
    font-family: "Roboto Slab", serif;
    h3 {
      color: #424b50;
      font-size: 23px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 16px;
      }
    }
    a {
      color: #27ce0a;
      font-family: "Roboto", sans-serif;
      font-weight: 400;
    }
  }
  .tabs-wrapper {
    justify-content: space-between;
    align-items: center;
    margin: 0 -10px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding-bottom: 12px !important;
    }
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      li {
        margin: 5px 0;
        .padding-bottom-checkbox-text {
          padding-bottom: 3px;
          color: rgb(126, 126, 126);
          font-size: 16px;
          font-family: "Roboto Slab", serif;
          font-weight: 500;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 12px;
          }
        }
        li {
          margin: 0 10px;
          &.disable-button {
            pointer-events: none;
            opacity: 0.6;
          }
        }
        &.custom-size {
          div[class$="-control"] {
            min-width: 166px;
          }
        }
        &.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
      }
    }
    p.articles-count {
      margin-bottom: 0px;
      color: rgb(126, 126, 126);
      font-size: 14px;
      font-weight: 600;
      font-family: "robotomedium";
      white-space: nowrap;
      display: inline-block;
      float: right;
    }
  }
`;

export default StyledWrapper;
